export default __webpack_public_path__ + "static/media/logo.6a24a4a2.png";